// Generated by Melange

import * as Buhta_cabinet__CalendarMonthYear from "./CalendarMonthYear.js";
import * as Buhta_cabinet__CalendayMonthSelect from "./CalendayMonthSelect.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../packages/util/lib/DateTime.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function CalendarMonthYearPicker(Props) {
  let onPickedOpt = Props.onPicked;
  const onPicked = onPickedOpt !== undefined ? onPickedOpt : (function (param) {
      
    });
  const currentDate = DateTime.local(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  const match = React.useState(function () {
    return [
      DateTime.month(currentDate),
      DateTime.year(currentDate)
    ];
  });
  const setMonthYear = match[1];
  const match$1 = match[0];
  const year = match$1[1];
  const month = match$1[0];
  const match$2 = React.useState(function () {
    
  });
  const setSelectedDate = match$2[1];
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Buhta_cabinet__CalendayMonthSelect.make, {
        value: [
          month,
          year
        ],
        onChange: (function (month, year) {
          Curry._1(setMonthYear, (function (param) {
            return [
              month,
              year
            ];
          }));
        }),
        displayYearOnly: true
      }),
      JsxRuntime.jsx(Buhta_cabinet__CalendarMonthYear.make, {
        year: year,
        month: month,
        selectedStartMonth: match$2[0],
        selectedEndMonth: undefined,
        onMonthSelected: (function (month) {
          Curry._1(setSelectedDate, (function (param) {
            return Caml_option.some(month);
          }));
          Curry._1(onPicked, month);
        })
      })
    ],
    className: "p-4 bg-black inline-block rounded-sm w-90"
  });
}

const make = CalendarMonthYearPicker;

export {
  make,
}
/* Buhta_cabinet__CalendarMonthYear Not a pure module */
